<template>
	<div class="card-wrap pb-8">
		<h1 class="card--title text-center mb-1">
			{{ $t('easy-to-start.card4.title') }}
		</h1>
		<h1
			class="card--text text-center mb-3"
			v-html="$t('easy-to-start.card4.sub-title')"
		></h1>

		<div>
			<h1 class="style--title mb-1">
				{{ $t('easy-to-start.card4.style1-title') }}
			</h1>
			<v-row no-gutters class="mb-4">
				<v-col cols="6" class="pr-1">
					<div class="option py-3">
						{{ $t('easy-to-start.card4.style1-1') }}
					</div>
				</v-col>
				<v-col cols="6" class="pl-1">
					<div class="option py-3 active">
						{{ $t('easy-to-start.card4.style1-2') }}
					</div>
				</v-col>
			</v-row>
			<h1 class="style--title mb-1">
				{{ $t('easy-to-start.card4.style2-title') }}
			</h1>
			<v-row no-gutters class="mb-4">
				<v-col cols="6" class="pr-1">
					<div class="option py-3 active">
						{{ $t('easy-to-start.card4.style2-1') }}
					</div>
				</v-col>
				<v-col cols="6" class="pl-1">
					<div class="option py-3">
						{{ $t('easy-to-start.card4.style2-2') }}
					</div>
				</v-col>
			</v-row>
			<h1 class="style--title mb-1">
				{{ $t('easy-to-start.card4.style3-title') }}
			</h1>
			<v-row no-gutters class="mb-4">
				<v-col cols="6" class="pr-1">
					<div
						class="option active"
						:class="language === 'ja' ? 'py-5' : 'py-3'"
					>
						{{ $t('easy-to-start.card4.style3-1') }}
					</div>
				</v-col>
				<v-col cols="6" class="pl-1">
					<div class="option py-3">
						<span v-html="$t('easy-to-start.card4.style3-2')"></span>
					</div>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.card-wrap {
	padding: 40px 36px 0;
	border-radius: 20px;
	box-shadow: 0 11px 33px 0 rgba(33, 51, 82, 0.1);
	background-color: #fff;
}
.card--title {
	font-family: NotoSansKR;
	font-size: 22px;
	font-weight: bold;
	color: #1a1a1a;
}
.card--text {
	font-size: 16px;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	font-weight: normal;
}
.style--title {
	font-size: 12.1px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.61px;
	color: #1a1a1a;
}
.option {
	border-radius: 11px;
	border: solid 1.1px #dfdfdf;
	background-color: #fff;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.44px;
	text-align: center;
	color: #888;
}
@media screen and (max-width: 600px) {
	.option {
		font-size: 14px;
	}
}

.option.active {
	border: solid 1.1px #0074ff;
	background-color: #ebf4ff;
	color: #0074ff;
}
</style>
